<template>
    <section id="services" class="py-20 lg:py-28">
        <div class="container mx-auto px-4">
            <h2 v-if="content.heading" class="text-3xl md:text-4xl font-bold text-center text-foreground mb-4">
                {{ content.heading }}
            </h2>
            <p v-if="content.subheading" class="text-center text-muted-foreground mb-14 max-w-2xl mx-auto">
                {{ content.subheading }}
            </p>

            <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6 max-w-4xl mx-auto">
                <div
                    v-for="(item, i) in items"
                    :key="i"
                    class="flex flex-col items-center gap-3 p-6 rounded-xl border border-border bg-card card-hover shadow-sm"
                >
                    <div class="w-14 h-14 rounded-xl bg-accent/15 flex items-center justify-center">
                        <BlockIcon :name="item.icon" class="text-accent" :size="28" />
                    </div>
                    <span class="text-sm font-semibold text-foreground text-center leading-tight">
                        {{ item.label }}
                    </span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import BlockIcon from "./BlockIcon.vue";

export default {
    name: "ServicesBlock",
    components: { BlockIcon },
    props: { content: { type: Object, default: () => ({}) } },
    computed: {
        items() {
            return this.content.items || [];
        },
    },
};
</script>
